<vdr-card [title]="'customers-pay-methods.payment_method' | translate" class="xxx">
  <!-- The data table -->
  <vdr-data-table-2
    id="payment-methods-list"
    [items]="data"
    [totalItems]="totalItems$"
  >
      <!-- Here we define all the available columns -->
      <vdr-dt2-column id="id" [heading]="'common.id' | translate" [hiddenByDefault]="true">
          <ng-template let-payMethod="item">
              {{ payMethod.id }}
          </ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column id="maskNumber" [heading]="'customers-pay-methods.mask_number' | translate">
          <ng-template let-paymentMethod="item">{{ paymentMethod.maskNumber }}</ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column id="type" [heading]="'customers-pay-methods.type' | translate">
          <ng-template let-paymentMethod="item">
            <span [innerHTML]="'customers-pay-methods.' + paymentMethod.type | translate"></span>
          </ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column id="cardBrand" [heading]="'customers-pay-methods.card_brand' | translate">
          <ng-template let-paymentMethod="item">{{ paymentMethod.cardBrand }}</ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column
        id="expire-at"
        [heading]="'customers-pay-methods.expire_at' | translate"
      >
        <ng-template let-paymentMethod="item">
            {{ paymentMethod.expireAt | localeDate : 'short' }}
        </ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column
        id="created-at"
        [heading]="'common.created-at' | translate"
        [hiddenByDefault]="true"
      >
        <ng-template let-paymentMethod="item">
            {{ paymentMethod.createdAt | localeDate : 'short' }}
        </ng-template>
      </vdr-dt2-column>
  </vdr-data-table-2>
</vdr-card>
